<rappider-ai-abstract-chat *ngIf="selectedProjectModel || componentDefinitionId"
                           [aiFunctionId]="aiFunctionIds.ENTITY_COMPONENT"
                           [activeProjectId]="activeProjectId"
                           [activePersonId]="activePersonId"
                           [selectedProjectModelId]="selectedProjectModelId"
                           [componentDefinitionId]="componentDefinitionId"
                           [aiStartConfig]="aiStartConfig"
                           [splitterRightContainerSize]="shouldOpenCanvas ? 800 : 0"
                           [showExamplePrompts]="true"
                           [examplePrompts]="examplePrompts"
                           (messageSent)="onMessageSent($event)"
                           (responseAction)="onResponseAction($event)"
                           (splitterToggleRequested)="onSplitterToggleRequested($event)"
                           (revertRequested)="onRevertRequested($event)"
                           #abstractChat></rappider-ai-abstract-chat>

<ng-container *ngIf="!selectedProjectModel && !selectedProjectModelNotFound && selectedProjectModelId">
  <div class="no-project-model-selected-content">
    <h2>Entity Visualization AI</h2>
    <h4>Loading ...</h4>
    <nz-skeleton [nzActive]="true"
                 [nzParagraph]="true"></nz-skeleton>
  </div>
</ng-container>

<section *ngIf="(!selectedProjectModelId && !componentDefinitionId) || (selectedProjectModelNotFound && !componentDefinitionId)"
         class="no-project-model-selected">
  <div class="no-project-model-selected-content">
    <h2>Entity Visualization AI</h2>
    <h2><i class="fa-solid fa-square-exclamation"></i>&nbsp;No Project Model {{selectedProjectModelNotFound? 'Found' :
      'Selected'}}</h2>
    <p>Please select a project model to start generating entity components.</p>
    <button nz-button
            nzType="primary"
            (click)="navigateToProjectModelSelection()">Select a Project Model</button>
  </div>
</section>
